import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplateSignature from '@/shared/http/repositories/business/qmaTemplateSignature'
import { loading } from '@/shared/utils/UIHelper'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'
import draggable from 'vuedraggable'

export default {
  name: 'signatureTemplate',
  props: ['templateid', 'novosItensTableAssinatura'],
  components: {draggable},
  mixins: [ActionsForm],
  data () {
    return {
      dataTemplateQMAAssinatura: [],
      dataEdicoesCancelar: [],
      dataItensChecadoEdicoesCancelar: [],
      dataEdicoesInativoCancelar: [],
      dataEdicoesAtivoCancelar: [],
      liberaExclusaoEdicao: false,
      notFound: ImageNotFound
    }
  },
  watch: {
    novosItensTableAssinatura (value) {
      this.dataTemplateQMAAssinatura.push(...value)
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onDragChange (event) {
      // Identifica a posição inicial e final do item movido
      if (event.moved) {
        // Identifica a posição inicial e final do item movido
        const oldIndex = event.moved.oldIndex // Índice original
        const newIndex = event.moved.newIndex // Índice final
        this.dataTemplateQMAAssinatura.sort((a, b) => a.nivelPrioridade - b.nivelPrioridade)

        // Referência aos dois itens que trocaram de posição
        const itemMovido = this.dataTemplateQMAAssinatura[newIndex]
        const itemSubstituido = this.dataTemplateQMAAssinatura[oldIndex]

        // Armazena o valor original de nivelPrioridade do itemMovido
        const originalNivelPrioridadeMovido = itemMovido.nivelPrioridade

        // Atualiza os valores de nivelPrioridade e outras propriedades
        itemMovido.nivelPrioridade = itemSubstituido.nivelPrioridade
        itemMovido.edicao = true
        itemMovido.descricaoEdicao = 'AG. ENVIO - EDIÇÃO NÍVEL PRIORIDADE'
        itemMovido.colorStatus = 'rgb(255, 216, 187)'
        itemMovido.colorFonte = 'rgb(188, 72, 7)'

        itemSubstituido.nivelPrioridade = originalNivelPrioridadeMovido
        itemSubstituido.edicao = true
        itemSubstituido.descricaoEdicao = 'AG. ENVIO - EDIÇÃO NÍVEL PRIORIDADE'
        itemSubstituido.colorStatus = 'rgb(255, 216, 187)'
        itemSubstituido.colorFonte = 'rgb(188, 72, 7)'

        // Criação dos objetos para emissão
        const movido = {
          id: itemMovido.id,
          nivelPrioridade: itemMovido.nivelPrioridade
        }

        const substituido = {
          id: itemSubstituido.id,
          nivelPrioridade: itemSubstituido.nivelPrioridade
        }

        // Cria o array e adiciona os objetos
        const Nivelajustado = []
        Nivelajustado.push(substituido, movido)

        // Emite o evento com os dados atualizados
        this.$emit('AlterandoNivelPrioridadeAssinatura', Nivelajustado)

        this.dataTemplateQMAAssinatura.sort((a, b) => a.nivelPrioridade - b.nivelPrioridade)
      }
    },
    addassinatura () {
      this.$emit('popUpAssinatura', true)
    },
    onLoad () {
      loading.push()
      qmaTemplateSignature.GetQMATemplateListaAssinatura(this.templateid)
        .then((Response) => {
          loading.pop()
          this.dataTemplateQMAAssinatura = Response.data.data
        })
    },
    CheckboxAtivacaoInativacao (id, status) {
      if (status !== 1) {
        this.AtivacaoInativacao('AG. ENVIO - ATIVAÇÃO', false, true, id, 'rgb(28, 98, 40)', 'rgb(203, 233, 207)')
      } else {
        this.AtivacaoInativacao('AG. ENVIO - INATIVAÇÃO', true, false, id, 'rgb(136, 22, 22)', 'rgb(255, 205, 205)')
      }
    },
    AtivacaoInativacao (descricao, inativacao, ativacao, id, fonte, status) {
      for (let i = 0; i < this.dataTemplateQMAAssinatura.length; i++) {
        if (this.dataTemplateQMAAssinatura[i].id === id) {
          this.dataTemplateQMAAssinatura[i].edicao = true
          this.dataTemplateQMAAssinatura[i].status = inativacao === true ? 0 : 1
          this.dataTemplateQMAAssinatura[i].descricaoEdicao = descricao
          this.dataTemplateQMAAssinatura[i].colorStatus = status
          this.dataTemplateQMAAssinatura[i].ativo = ativacao
          this.dataTemplateQMAAssinatura[i].inativo = inativacao
          this.dataTemplateQMAAssinatura[i].colorFonte = fonte
          if (ativacao === true) {
            this.$emit('addEdicaoAtivacaoAssinatura', id)
          }
          if (inativacao === true) {
            this.$emit('addEdicaoInativacaoAssinatura', id)
          }
        }
      }
    },
    CheckExclusaoEdicao (id, value) {
      for (let i = 0; i < this.dataTemplateQMAAssinatura.length; i++) {
        if (this.dataTemplateQMAAssinatura[i].id === id) {
          this.dataTemplateQMAAssinatura[i].check = value
        }
      }
    },

    verificaCamposCheck () {
      let existeCheckTrue = this.dataTemplateQMAAssinatura.some(item => item.check === true)

      if (existeCheckTrue === false) {
        this.liberaExclusaoEdicao = false
      } else {
        this.liberaExclusaoEdicao = true
      }
      this.$emit('liberaButonEdicaoExclusao', this.liberaExclusaoEdicao)
    },
    AdicionarItenParaExclusaoDaEdicao (id) {
      this.Adicionar = !this.Adicionar
      var div = document.getElementById(id.id)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.dataEdicoesCancelar = this.dataEdicoesCancelar.filter(item => item !== id.id)
        this.dataItensChecadoEdicoesCancelar = this.dataItensChecadoEdicoesCancelar.filter(item => item !== id.id)

        this.CheckExclusaoEdicao(id.id, false)
        this.verificaCamposCheck()
      } else {
        div.classList.add('clicked')

        if (id.add === true) {
          if (this.dataEdicoesCancelar !== null && this.dataEdicoesCancelar !== undefined && this.dataEdicoesCancelar.length > 0) {
            this.dataEdicoesCancelar.push(id.id)
            this.dataItensChecadoEdicoesCancelar.push(id.id)
          } else {
            this.dataEdicoesCancelar[0] = id.id
            this.dataItensChecadoEdicoesCancelar[0] = id.id
          }
        }

        if (id.inativo === true) {
          if (this.dataEdicoesInativoCancelar !== null && this.dataEdicoesInativoCancelar !== undefined && this.dataEdicoesInativoCancelar.length > 0) {
            this.dataEdicoesInativoCancelar.push(id.id)
          } else {
            this.dataEdicoesInativoCancelar[0] = id.id
          }
        }

        if (id.ativo === true) {
          if (this.dataEdicoesAtivoCancelar !== null && this.dataEdicoesAtivoCancelar !== undefined && this.dataEdicoesAtivoCancelar.length > 0) {
            this.dataEdicoesAtivoCancelar.push(id.id)
          } else {
            this.dataEdicoesAtivoCancelar[0] = id.id
          }
        }

        this.CheckExclusaoEdicao(id.id, true)
        this.verificaCamposCheck()
      }
    },
    removerItemTable () {
      for (let i = 0; i < this.dataEdicoesCancelar.length; i++) {
        let idCancelar = this.dataEdicoesCancelar[i]

        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMAAssinatura.length; j++) {
          if (this.dataTemplateQMAAssinatura[j].id === idCancelar) {
            this.dataTemplateQMAAssinatura.splice(j, 1)
            j--
            this.verificaCamposCheck()
            break
          }
        }
      }
      this.dataEdicoesCancelar = []
    },
    removerEdicoesInativacaoTable () {
      for (let i = 0; i < this.dataEdicoesInativoCancelar.length; i++) {
        let idCancelarInativacao = this.dataEdicoesInativoCancelar[i]
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMAAssinatura.length; j++) {
          if (this.dataTemplateQMAAssinatura[j].id === idCancelarInativacao) {
            this.dataTemplateQMAAssinatura[j].status = 1
            this.dataTemplateQMAAssinatura[j].descricaoEdicao = ''
            this.dataTemplateQMAAssinatura[j].inativo = false
            this.dataTemplateQMAAssinatura[j].edicao = false
            this.dataTemplateQMAAssinatura[j].check = false
            this.verificaCamposCheck()
            break
          }
        }
      }
    },
    removerEdicoesAtivacaoTable () {
      for (let i = 0; i < this.dataEdicoesAtivoCancelar.length; i++) {
        let idCancelarInativacao = this.dataEdicoesAtivoCancelar[i]
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMAAssinatura.length; j++) {
          if (this.dataTemplateQMAAssinatura[j].id === idCancelarInativacao) {
            this.dataTemplateQMAAssinatura[j].status = 0
            this.dataTemplateQMAAssinatura[j].descricaoEdicao = ''
            this.dataTemplateQMAAssinatura[j].inativo = false
            this.dataTemplateQMAAssinatura[j].ativo = false
            this.dataTemplateQMAAssinatura[j].edicao = false
            this.dataTemplateQMAAssinatura[j].check = false
            this.verificaCamposCheck()
            break
          }
        }
      }
    },
    removerEdicoesInativacaoAtivacaoRetonarCasoTenhaItemEdicaoTable () {
      // Encontra o índice do objeto a ser removido
      for (let j = 0; j < this.dataTemplateQMAAssinatura.length; j++) {
        if (this.dataTemplateQMAAssinatura[j].ativo === true || this.dataTemplateQMAAssinatura[j].inativo === true || this.dataTemplateQMAAssinatura[j].edicao === true) {
          return true
        }
      }
    },
    limparItensEdicao () {
      if (this.dataItensChecadoEdicoesCancelar.length > 0) {
        this.$emit('removerItensparaEdicaoExclusaoAssinatura', this.dataItensChecadoEdicoesCancelar)
      }
      if (this.dataEdicoesAtivoCancelar.length > 0) {
        this.$emit('removerItensparaEdicaoAtivacaoAssinaturaExclusao', this.dataEdicoesAtivoCancelar)
      }
      if (this.dataEdicoesInativoCancelar.length > 0) {
        this.$emit('removerItensparaEdicaoInativacaoAssinaturaExclusao', this.dataEdicoesInativoCancelar)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/signatureTemplate/signatureTemplate.js